module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.service) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "1200px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Booking-Service #" + _vm._s(_vm.service.booking_id) + "-" + _vm._s(_vm.service.service_id))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info"
  }, [_vm._v("Hotel")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-bed"
  }), _vm._v(" " + _vm._s(_vm.service.room.hotel.name))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v("\n                " + _vm._s(_vm.service.room.description.substring(0, 45)) + "\n                "), (_vm.service.room.description.length > 45) ? [_c('tooltip', {
    staticStyle: {
      "word-break": "break-all"
    },
    attrs: {
      "label": _vm.service.room.description,
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "is-small"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])])] : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  }), _vm._v(" " + _vm._s(_vm.service.room.board_description))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.service.service_date, 'YYYY-MM-DD')))]), _vm._v(" to "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.service.service_date, 'add', _vm.service.room.number_nights + ' days', 'YYYY-MM-DD')))])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.service.paxes.length))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" Adults: "), _c('b', [_vm._v(_vm._s(_vm.service.room.number_adults))]), _vm._v(" Children: "), _c('b', [_vm._v(_vm._s(_vm.service.room.number_children))])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-moon-o"
  }), _vm._v(" " + _vm._s(_vm.service.room.number_nights))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" Net: "), _c('b', [_vm._v(_vm._s(_vm.service.price + " " + _vm.service.currency))]), _vm._v(" Provider: "), _c('b', [_vm._v(_vm._s(_vm.service.room.provider_price + " " + _vm.service.room.provider_currency))])]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.service.room.hotel.city.name))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" " + _vm._s(_vm.service.room.hotel.address))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.service.room.hotel.phone))])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "panel panel-warning"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-warning"
  }, [_vm._v("Broker Info")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_vm._v(" " + _vm._s(_vm.service.room.provider.name))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  }), _vm._v(" " + _vm._s(_vm.service.room.provider_booking_code))]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" " + _vm._s(_vm.service.reservation_date))]), _vm._v(" "), _c('p', {
    staticClass: "panel-heading panel-heading-warning"
  }, [_vm._v("Customer Info")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_vm._v("Agency: "), _c('b', [_vm._v(_vm._s(_vm.service.agency.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("Cancellation")]), _vm._v(" "), _vm._l((_vm.service.room.cancellation), function(cancellation) {
    return _c('p', {
      staticClass: "panel-block"
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" "), _c('b', [_vm._v("From: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(cancellation.start_date, 'YYYY-MM-DD hh:mm A')) + " "), _c('b', [_vm._v("To: ")]), _vm._v(_vm._s(_vm._f("moment")(cancellation.end_date, 'YYYY-MM-DD hh:mm A')) + " "), _c('b', [_vm._v("Value: "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(" " + _vm._s(parseFloat(cancellation.price).toFixed(2)) + " " + _vm._s(cancellation.currency))])]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(parseInt(cancellation.type) === 1 ? 'Provider' : 'Operator'))])])
  })], 2)])]), _vm._v(" "), (_vm.service.observation && _vm.service.observation !== '') ? [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('p', {
    staticClass: "panel-heading panel-heading-info"
  }, [_vm._v("Observation")]), _vm._v(" "), _c('p', {
    staticClass: "panel-block"
  }, [_c('pre', [_vm._v(_vm._s(_vm.service.observation))])])])])])] : _vm._e(), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("Cheaper Rooms")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.availability == null) ? [_vm._m(1)] : [(_vm.availability.length > 0) ? _vm._l((_vm.tableSearch), function(room) {
    return (_vm.availability) ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRoom),
        expression: "selectedRoom"
      }],
      attrs: {
        "type": "radio",
        "id": "room",
        "name": "room"
      },
      domProps: {
        "value": room,
        "checked": _vm._q(_vm.selectedRoom, room)
      },
      on: {
        "change": function($event) {
          _vm.selectedRoom = room
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(room.RoomDescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(room.BoardDescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(room.SupplierName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(room.hasOwnProperty('OperatorCancellationPolicies') ? _vm.parseDate(room.OperatorCancellationPolicies.CancellationPolicy.StartDate) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(room.SellPriceTotal.Value) + " " + _vm._s(room.SellPriceTotal.Currency))])]) : _vm._e()
  }) : [_vm._m(2)]]], 2)])], 2)]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('a', {
    staticClass: "button is-success",
    class: {
      'is-disabled': _vm.selectedRoom === null
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('a', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        return _vm.exclude()
      }
    }
  }, [_vm._v("Remove")])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Room")]), _vm._v(" "), _c('th', [_vm._v("Board")]), _vm._v(" "), _c('th', [_vm._v("Supplier")]), _vm._v(" "), _c('th', [_vm._v("Cancellation")]), _vm._v(" "), _c('th', [_vm._v("Value")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw",
    staticStyle: {
      "font-size": "90px"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                    Rates are no longer available\n                  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18ce6238","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/bi/Change.vue
// module id = 1078
// module chunks = 39